const STORAGE_KEY = 'esc-recents';
const MAX_RECENTS = 20;

export const RECENTS_CHANGED_EVENT = 'esc-recents-changed';

export interface RecentItem {
  type: 'dossier';
  id: string; // dossierId
  dossierId: string;
  title: string; // dossier_name
  subtitle: string; // client_dossier_id
  path: string; // /claims/:dossierId
  visitedAt: number;
  unread?: boolean;
}

export function getRecents(): RecentItem[] {
  try {
    const items: RecentItem[] = JSON.parse(
      localStorage.getItem(STORAGE_KEY) || '[]'
    );
    return items.sort((a, b) => b.visitedAt - a.visitedAt);
  } catch {
    return [];
  }
}

function saveRecents(items: RecentItem[]): void {
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify(items.slice(0, MAX_RECENTS))
  );
  window.dispatchEvent(new CustomEvent(RECENTS_CHANGED_EVENT));
}

export function addRecent(item: RecentItem): void {
  const existing = getRecents();
  const rest = existing.filter((r) => r.id !== item.id);
  rest.unshift({ ...item, unread: false });
  saveRecents(rest);
}

export function markRecentRead(id: string): void {
  const items = getRecents().map((r) =>
    r.id === id ? { ...r, unread: false } : r
  );
  saveRecents(items);
}

export function markRecentUnread(id: string): void {
  const items = getRecents().map((r) =>
    r.id === id ? { ...r, unread: true } : r
  );
  saveRecents(items);
}
